module.exports = __webpack_public_path__ + "static/img/pay-ok.c64413da.png";